<template>
  <div>
    <Mobile class="uk-hidden@m" :filters="resolveMobileFilters" :sorting="sorting"></Mobile>
    <div class="ipad-margin uk-visible@m top-margin">
      <span class="filter-Results">{{$t('general.narrowResults')}}</span>
      <div class="author-filter-container">
        <div v-if="author" class="author-filter uk-text-truncate">
          <span class="add-pointer uk-text-middle"
                @click="clearAuthor"
                @mouseover="resolveIcon(true, AUTHOR)"
                @mouseleave="resolveIcon(false, AUTHOR)">
            <img :data-src="authorClose" class="icon-dimensions" uk-img>
          </span>
          <span class="uk-text-middle">{{this.author}}</span>
        </div>
        <div v-if="keyword" class="author-filter uk-text-truncate">
          <span class="add-pointer uk-text-middle"
                @click="clearKeyword"
                @mouseover="resolveIcon(true, KEYWORD)"
                @mouseleave="resolveIcon(false, KEYWORD)">
            <img :data-src="keywordClose" class="icon-dimensions" uk-img>
          </span>
          <span class="uk-text-middle">{{this.keyword}}</span>
        </div>
        <div v-if="selectedCategory" class="author-filter uk-text-truncate">
          <span class="add-pointer uk-text-middle"
                @click="clearCategory"
                @mouseover="resolveIcon(true, CATEGORY)"
                @mouseleave="resolveIcon(false, CATEGORY)">
            <img :data-src="categoryClose" class="icon-dimensions" uk-img>
          </span>
          <span class="uk-text-middle">{{this.resolveSelectedCategory}}</span>
        </div>
      </div>
      <DesktopFilter style="margin-bottom:13px;" v-for="(filter, index) in resolveDesktopFilters" :key="index" :filters="filters"
                     :filter="filter.title"></DesktopFilter>
      <hr>
      <button v-if="filtersSelected || author" class="button-clear-filters text-clear-filters uk-width-1-1 add-pointer"
              @click="clearFilters">{{$t('filters.clear')}}
      </button>
    </div>
  </div>
</template>
<script>
  import DesktopFilter from './desktop/desktop-filter'
  import Mobile from './mobile/mobile'
  import {mapGetters, mapActions} from 'vuex'
  import * as misc from '../../../enums/misc'
  import iconUtil from '../../../utils/icon-util'
  import * as categories from '../../../enums/categories'

  export default {
    name: 'Filters',
    components: {
      DesktopFilter,
      Mobile
    },
    data() {
      return {
        grades: 'Grades',
        authorClose: iconUtil.resolve(misc.CLOSE_SLATE),
        keywordClose: iconUtil.resolve(misc.CLOSE_SLATE),
        categoryClose: iconUtil.resolve(misc.CLOSE_SLATE),
        AUTHOR: 'author',
        KEYWORD: 'keyword',
        CATEGORY: 'category'
      }
    },
    computed: {
      ...mapGetters(['filters', 'sorting', 'author', 'keyword', 'selectedCategory']),
      filtersSelected() {
        let count = 0
        for (let filter of this.filters) {
          for (let item of filter.items) {
            if (item.id !== 'all') {
              if (item.selected) {
                count += 1
              }
            }
          }
        }
        return count
      },
      resolveSelectedCategory() {
        switch (this.selectedCategory) {
          case categories.FEATURED_CONTENT:
            return this.$t('homeContent.featuredContent')
          case categories.STUDENT_ACTIVITIES:
            return this.$t('homeContent.studentActivities')
          case categories.MOST_POPULAR_RESOURCES:
            return this.$t('homeContent.mostPopularResources')
          case categories.MANAGE_YOUR_CLASSROOM:
            return this.$t('homeContent.manageYourClassroom')
          case categories.TRY_SOMETHING_NEW:
            return this.$t('homeContent.trySomethingNew')
          case categories.STANDARDS_CONTENT:
            return this.$t('homeContent.standardsContent')
          case categories.TOP_SECONDARY:
            return this.$t('homeContent.topSecondary')
          case categories.TOP_PRIMARY:
            return this.$t('homeContent.topPrimary')
          case categories.FEATURED_PUBLISHER_CONTENT:
            return this.$t('homeContent.featuredPublisherContent')
        }
      },
      resolveDesktopFilters () {
        return this.filters.filter(x => x.title !== 'Strands')
      },
      resolveMobileFilters() {
        return this.filters
      }
    },
    methods: {
      ...mapActions(['setDefaultFilters', 'updateAuthorFilter', 'updateKeywordFilter', 'updateSelectedCategory']),
      clearFilters() {
        this.setDefaultFilters(this.filters)
        this.clearAuthor()
        this.clearKeyword()
        this.clearCategory()
      },
      clearAuthor() {
        this.updateAuthorFilter(null)
        let query = this.$route.query
        query.author = undefined
        this.$router.replace({query: null},
          () => this.$router.replace({query})
        )
      },
      clearKeyword() {
        this.updateKeywordFilter(null)
      },
      clearCategory() {
        this.updateSelectedCategory(null)
      },
      resolveIcon(hover, type) {
        if (hover) {
          switch (type) {
            case this.AUTHOR:
              this.authorClose = iconUtil.resolve(misc.CLOSE_BLUE)
              break
            case this.KEYWORD:
              this.keywordClose = iconUtil.resolve(misc.CLOSE_BLUE)
              break
            case this.CATEGORY:
              this.categoryClose = iconUtil.resolve(misc.CLOSE_BLUE)
          }
        } else {
          switch (type) {
            case this.AUTHOR:
              this.authorClose = iconUtil.resolve(misc.CLOSE_SLATE)
              break
            case this.KEYWORD:
              this.keywordClose = iconUtil.resolve(misc.CLOSE_SLATE)
              break
            case this.CATEGORY:
              this.categoryClose = iconUtil.resolve(misc.CLOSE_SLATE)
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../src/styles/colours.scss';
  @import '../../../../src/styles/breakpoints.scss';

  hr {
    background: $slate;
    opacity: 0.2;
    height: 2px;
    margin-bottom: 10px;
  }

  .button-clear-filters {
    background-color: white;
    color: $slate;
    border-radius: 2px;
    border: solid 2px $slate;
    height: 44px;

    &:hover {
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2.8px white;
    }
  }

  .text-clear-filters {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: $slate;
  }

  .top-margin {
    margin-top: 39px;
  }

  .filter-Results {
    font-size: 18px;
    font-weight: bold;

  }

  .author-filter-container {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .author-filter {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    border-radius: 2px;
    background-color: #ffffff;
    padding-right: 10px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);

    &:hover {
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    }
  }

  .icon-dimensions {
    width: 34px;
    height: 34px;
  }

  @media screen and (max-width: $breakpoint-medium) and (min-width: ($breakpoint-medium - 1)) {
    .ipad-margin {
      margin-left: 10px;
    }
  }
</style>
